import React from 'react';
import {
  ApModal,
  ApButtonGroup,
  ApButtonSecondary,
  ApButtonDanger,
} from '@alixpartners/ui-components';

export const ConfirmationDialog = ({
  confirmText,
  isOpen,
  title,
  message,
  onConfirm,
  onClose,
}: {
  confirmText: string;
  isOpen: boolean;
  title: string;
  message: React.ReactNode;
  onConfirm: () => void;
  onClose: () => void;
}) => (
  <ApModal
    isDismissible
    isOpen={isOpen}
    hasClosed={onClose}
    header={title}
    footer={({ handleClose }) => (
      <ApButtonGroup justifyContent="flex-end">
        <ApButtonSecondary onClick={() => handleClose && handleClose()}>
          Cancel
        </ApButtonSecondary>
        <ApButtonDanger onClick={onConfirm}>{confirmText}</ApButtonDanger>
      </ApButtonGroup>
    )}
  >
    <div>{message}</div>
  </ApModal>
);

export default ConfirmationDialog;
